module.exports = kolibriGlobal.resources;